import { Product } from '@/hooks/use-jurisdiction';

import { mapVerticalToProduct } from './deeplink-referred-product';

/**
 * Resolves a promo code to a Product using the Prismic `promo_code_default_product_sync`
 * map (promo code -> vertical value). The key match is case-insensitive, and the
 * mapped value is normalised via {@link mapVerticalToProduct}.
 *
 * @returns The corresponding Product, or null if the code / value is unrecognised.
 */
export const mapPromoCodeToProduct = (code: string, syncMap: Record<string, string> | undefined): Product | null => {
    if (!code || !syncMap) {
        return null;
    }

    const normalised = code.toLowerCase().trim();
    const entry = Object.entries(syncMap).find(([key]) => key.toLowerCase().trim() === normalised);

    return entry ? mapVerticalToProduct(entry[1]) : null;
};
